// TODO this should be an enum default
export const receiptDefaultValues = {
  deliveryState: 'Undamaged',
  deliveryStatus: 'Accepted',
};
